import { ActionTypes } from '../constants';

export function updateChecks(checks: Object) {
  return {
    type: ActionTypes.UPDATE_CHECK,
    payload: {
      checks,
    },
  };
}

export function deleteChecks(checkHeaderIds: Array<Number>) {
  return {
    type: ActionTypes.DELETE_CHECKS,
    payload: {
      checkHeaderIds,
    },
  };
}

export function clearChecks() {
  return {
    type: ActionTypes.CLEAR_CHECKS,
  };
}

export function updateSyncStatus(status: string) {
  return {
    type: ActionTypes.UPDATE_SYNC_STATUS,
    payload: {
      status,
    },
  };
}
